import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { ComparedProduct } from 'b2b-common/core/product/api/ProductsCompare.types';
import { ProductsCompareState } from './types';

export const getState = (state: State): ProductsCompareState => state.product.productsCompare;

export const getProductsCompareData = (
  state: State,
): RemoteRecord<ComparedProduct[]> => new RemoteRecord(getState(state));
